import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { products } from '@/mocks/products';

export default function ShopPage() {
  const [activeCategory, setActiveCategory] = useState('All');
  const categories = ['All', ...Array.from(new Set(products.map((p) => p.category)))];
  const filtered =
    activeCategory === 'All'
      ? products
      : products.filter((p) => p.category === activeCategory);

  return (
    <>
      <Navbar />
      <main>
        <section className="pt-28 md:pt-36 pb-10 md:pb-14 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 text-center">
            <p className="text-primary-500 font-label text-sm tracking-[0.15em] uppercase mb-3">
              Take Home the Experience
            </p>
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-900 mb-4">
              Green Tea Shop
            </h1>
            <p className="text-foreground-600 max-w-2xl mx-auto text-base md:text-lg">
              Premium Afghan green tea and specialty blends, carefully sourced
              and beautifully packaged for your home.
            </p>
          </div>
        </section>

        <section className="py-12 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
            <div className="flex flex-wrap items-center justify-center gap-2 mb-10 md:mb-12">
              {categories.map((cat) => (
                <button
                  key={cat}
                  onClick={() => setActiveCategory(cat)}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${
                    activeCategory === cat
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-700 hover:bg-background-200'
                  }`}
                >
                  {cat}
                </button>
              ))}
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
              {filtered.map((product) => (
                <div
                  key={product.id}
                  className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/60 hover:border-primary-300/50 transition-all duration-300"
                >
                  <Link to={`/product/${product.id}`} className="block">
                    <div className="relative aspect-square overflow-hidden bg-background-100">
                      <img
                        src={product.image}
                        alt={product.name}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      />
                      {product.badge && (
                        <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-medium rounded-full">
                          {product.badge}
                        </span>
                      )}
                    </div>
                    <div className="p-4 md:p-5">
                      <p className="text-xs text-foreground-500 font-label mb-1">
                        {product.category}
                      </p>
                      <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors">
                        {product.name}
                      </h3>
                      <p className="text-foreground-600 text-sm leading-relaxed mb-3 line-clamp-2">
                        {product.description}
                      </p>
                      <div className="flex items-center justify-between mb-4">
                        <span className="font-label text-primary-600 font-semibold text-base">
                          {product.price}
                        </span>
                        <span className="text-foreground-500 text-xs">
                          {product.weight}
                        </span>
                      </div>
                    </div>
                  </Link>
                  <div className="px-4 pb-4 md:px-5 md:pb-5">
                    <button className="w-full px-4 py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-md hover:bg-primary-600 transition-colors">
                      Add to Cart
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}